import type { PerformanceDatapoint } from 'owa-analytics';
import { isSharedCalendar } from './isSharedCalendar';
import { getSharedCalendarType } from './getSharedCalendarType';
import { getEffectiveRightsString } from './getEffectiveRightsString';
import type { CalendarEntry } from 'owa-graph-schema';

export const logCalendarSharingProperties = (
    datapoint: PerformanceDatapoint,
    calendarEntry: CalendarEntry | undefined
): void => {
    if (calendarEntry) {
        // Do not log calendarId if it is an email address
        const shouldLogCalendarId =
            calendarEntry.calendarId.id && !calendarEntry.calendarId.id.includes('@');

        if (shouldLogCalendarId) {
            datapoint.addCustomData({ calendarId: calendarEntry.calendarId.id });
        }

        datapoint.addCustomData({
            isSharedCalendar: isSharedCalendar(calendarEntry),
            sharingType: getSharedCalendarType(calendarEntry),
            effectiveRights: getEffectiveRightsString(calendarEntry),
        });
    }
};
